import { Screen } from 'quasar';

export function isZubieDialogOpen(state) {
  return state.openDialogCount > 0;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 */
export function mobileTitleDisplayed(state) {
  return Boolean(state.mobileTitle || state.mobileTitlePending) && (Screen.xs || Screen.mobileHeight);
}
